import React, { ComponentType } from 'react';
import { components, DropdownIndicatorProps } from 'react-select';
import { SelectArrow } from '@lt/components/icons-react/userflow';

import { DepartureOption } from '@lt/api/dist/types/departure';
import styled from 'styled-components';

export const DropdownIndicator: ComponentType<DropdownIndicatorProps<DepartureOption, false>> = (
  props
) => (
  <components.DropdownIndicator {...props}>
    <StyledSelectArrow width="10px" />
  </components.DropdownIndicator>
);

const StyledSelectArrow = styled(SelectArrow)`
  /**
    * костыль для safari 14.0.3 в задаче
    * https://leveltravel.atlassian.net/browse/LT-34323?atlOrigin=eyJpIjoiODhkNGJmYjAzMzRmNDVhZmEzYjZjYjVmNzY2OGYyZmIiLCJwIjoiaiJ9
  */
  height: -webkit-fill-available;
`;
